module.exports = __webpack_public_path__ + "static/img/home_logo_img.6c25362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo_img.png
// module id = 9sRf
// module chunks = 3